import React, { useMemo } from "react";
const RicosAlignmentContext = React.createContext(
  null
);
const RicosAlignmentContextProvider = ({
  textAlignment,
  children
}) => {
  const textAlignmentValue = useMemo(() => {
    return { textAlignment };
  }, [textAlignment]);
  return /* @__PURE__ */ React.createElement(RicosAlignmentContext.Provider, { value: textAlignmentValue }, children);
};
export {
  RicosAlignmentContext,
  RicosAlignmentContextProvider
};
//# sourceMappingURL=alignment-context.js.map
